module.exports = __webpack_public_path__ + "web-icons.e485ae8f6e0bd284db68.woff";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/fonts/web-icons/web-icons.woff?v=0.2.3
// module id = ../../../../../src/assets/fonts/web-icons/web-icons.woff?v=0.2.3
// module chunks = styles